import React, { useEffect, useRef, useState } from "react";
import styles from "./SearchBar.module.scss";
import search from "assets/images/v2/search.svg";
import x_mark from "assets/images/v2/x.svg";

type SearchBarProps = {
  onSearch: (query: string) => void;
  placeholder?: string;
  initialValue?: string;
};

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, placeholder = "Search", initialValue = "" }) => {
  const [value, setValue] = useState<string>(initialValue);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    onSearch(value);
  }, [value, onSearch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleClear = () => {
    setValue("");
    inputRef.current?.focus();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape") {
      e.preventDefault();
      handleClear();
    }
  };

  return (
    <div className={styles.searchContainer} aria-label="search-container">
      <div className={styles.searchField} role="search" aria-label="search-field">
        <img className={styles.searchIcon} alt="search" aria-label="search-icon" src={search} />
        <input
          ref={inputRef}
          className={styles.searchDocuments}
          type="text"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          aria-label="Search documents"
        />
        {value.length > 0 && (
          <button
            type="button"
            className={styles.searchClearButton}
            onClick={handleClear}
            aria-label="Clear search"
          >
            <img src={x_mark} alt="Clear search" aria-hidden="true" className={styles.searchClearIcon} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;


